// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e309becd","453":"4af3ef36","455":"58bf62c8","977":"90f57752"}[chunkId] + ".chunk.js";
};